<div class="connections-container" [appSkeleton]="isLoading()">
  <list-connections
  class="connections-list"
    [items]="sources()"
    [selectedId]="sourceSelectedId()"
    [collapsedConnections]="false"
    (select)="onSelectSource($event)"
    (create)="onCreate()"
    (delete)="onDelete($event)"
    (toggleCollapse)="onToggleCollapse($event)"
    (refreshStatus)="onRefreshConnectionsStatus()">
  </list-connections>

  <list-items-connected
    [appSkeleton]="isLoadingDatasets()"
    class="items-selected-list"
    [datasets]="datasetsSelected()"
    [seriesByDataset]="seriesByDataset()"
    [expandedDatasetId]="expandedDatasetId()"
    [loadingSeriesDatasetId]="loadingSeriesDatasetId()"
    [sourceSelectedId]="sourceSelectedId()"
    (loadSeries)="onLoadSeries($event)"
    (toggleDetails)="onToggleDetails($event)"
    (seriesAdded)="onSeriesAdded()"
    (seriesDelete)="onSeriesDelete($event)"
    (executionsStarted)="onExecutionsStarted()">
  </list-items-connected>
</div>
